const wisdomQuotes = [
  { text: 'Nature does not hurry, yet everything is accomplished', attribution: 'Laozi', type: 'classic' },
  { text: 'A prawn has one job: to be a prawn. A human has one job: to be a human.', attribution: 'Adapted from Zen teaching', type: 'adapted' },
  // consider removing this next one:
  //{ text: 'Becoming is illusion, only being is real', attribution: 'Parmenides', type: 'classic' },
  { text: 'Everything flows, and is, at the same time', attribution: 'Labby Labs', type: 'original' },
  { text: 'Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment', attribution: 'Buddha', type: 'classic' },
  { text: 'Muddy water is best cleared by leaving it alone', attribution: 'Alan Watts', type: 'classic' },
  { text: 'A prawn is always on time', attribution: 'Adapted from Laozi', type: 'adapted' },
  { text: 'Floating quietly, spring comes, and the seaweed grows by itself', attribution: 'Adapted from Zen teaching', type: 'adapted' },
  { text: 'When swimming, swim. When eating, eat', attribution: 'Adapted from Zen teaching', type: 'adapted' },
  //{ text: 'Realize deeply that the present moment is all you ever have', attribution: 'Eckhart Tolle', type: 'classic' },
  //{ text: 'You are an aperture through which the universe is looking at and exploring itself', attribution: 'Alan Watts', type: 'classic' },
  { text: 'Be like coral; breathe', attribution: 'Labby Labs', type: 'original' },
  //{ text: 'The way is not in the sky. The way is in the heart.', attribution: 'Buddha', type: 'classic' },
  //{ text: 'To be is enough.', attribution: 'Unknown', type: 'unknown' },
  //{ text: 'Time isn\'t wasted if life is tasted.', attribution: 'Goose', type: 'original' },
  //{ text: 'The quieter you become, the more you hear', attribution: 'Ram Dass', type: 'classic' },
  { text: 'Trust that you are exactly where you need to be, not where fear or comparison says you should be', attribution: 'Adapted from Shaolin teaching', type: 'adapted' },
];

// Fisher-Yates shuffle algorithm
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Create random order when module loads and loop through it
let shuffledQuotes = shuffleArray(wisdomQuotes);
let currentIndex = 0;

// Function to get a random wisdom quote (no repeats until all are viewed)
// Returns next quote, or null if all have been used
export const getRandomQuote = () => {
  if (currentIndex >= shuffledQuotes.length) {
    return null;
  }
  const quote = shuffledQuotes[currentIndex];
  currentIndex++;
  return quote;
};

// Returns true if all quotes have been used
export const allQuotesUsed = () => currentIndex >= shuffledQuotes.length;

export default wisdomQuotes;